// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l6_R","type":"styles_type__37jg4","choices":"styles_choices__6UfWu"};